import * as sentry from "@sentry/react";

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_STAGE,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Failed to fetch dynamically imported module",
      "Importing a module script failed",
      "Transition was aborted because of invalid state",
      "Unauthorized",
    ],
  });
}

export default sentry;
